<div class="app-not-installed-container">
  <div class="content-wrapper">

    <div class="logo-section">
      <img src="assets/icons/ic_farfisa_logo.png" alt="Farfisa Logo" class="logo">
    </div>

    <div class="message-section">
      <h1 class="title">{{ 'AppNotInstalled.Title' | i18nextEager }}</h1>
      <p class="subtitle">{{ 'AppNotInstalled.Subtitle' | i18nextEager }}</p>
    </div>

    <div class="auto-redirect-section" *ngIf="!showManualOptions">
      <div class="loading-spinner">
        <div class="spinner"></div>
      </div>
      <p class="redirect-message">
        <span *ngIf="deviceInfo.isAndroid">{{ 'AppNotInstalled.RedirectingAndroid' | i18nextEager }}</span>
        <span *ngIf="deviceInfo.isIOS">{{ 'AppNotInstalled.RedirectingIOS' | i18nextEager }}</span>
      </p>
    </div>

    <div class="download-options" *ngIf="showManualOptions">
      <h2 class="options-title">{{ 'AppNotInstalled.DownloadOptions' | i18nextEager }}</h2>

      <div class="mobile-downloads">
        <button class="store-button android-button" (click)="redirectToAndroidApp()">
          <svg-icon src="assets/icons/ic_android.svg" class="store-icon"></svg-icon>
          <div class="button-text">
            <span class="download-text">{{ 'AppNotInstalled.DownloadOn' | i18nextEager }}</span>
            <span class="store-name">Google Play</span>
          </div>
        </button>

        <button class="store-button ios-button" (click)="redirectToIOSApp()">
          <svg-icon src="assets/icons/ic_ios.svg" class="store-icon"></svg-icon>
          <div class="button-text">
            <span class="download-text">{{ 'AppNotInstalled.DownloadOn' | i18nextEager }}</span>
            <span class="store-name">App Store</span>
          </div>
        </button>
      </div>
    </div>

    <div class="info-section" *ngIf="showManualOptions">
      <p class="info-text">{{ 'AppNotInstalled.InfoText' | i18nextEager }}</p>
    </div>
  </div>
</div>
